const formatNumbers = (input, decimal = 2) => {
  return Number(input).toFixed(decimal);
};

export default formatNumbers;
